<div #youTubePlayer>
  <youtube-player
    [width]="videoWidth"
    [height]="videoHeight"
    [videoId]="videoID"
    placeholderImageQuality="standard"
  ></youtube-player>
</div>
